// src/components/ContactLinks.jsx
import React from "react";
import { isMobileNumber, trackActivityContact, API_NODE_BASE } from "../utils/contactUtils";

// ─── Props ────────────────────────────────────────────────────────────────────
// contacts    : { phone, whatsapp, website, email }
// entityId    : stringa identificativa (osmId, id attività, ecc.)
// entityType  : "activity" | "poi" | "event"
// placement   : stringa per il tracking (es. "map_popup", "list_card")

export default function ContactLinks({
    contacts,
    entityId,
    entityType = "activity",
    placement = "map_popup",
}) {
    if (!contacts) return null;

    const base = `${API_NODE_BASE}/go/contact?entityType=${entityType}&id=${encodeURIComponent(entityId)}&placement=${placement}`;
    const showWhatsapp = !!(contacts.whatsapp || (contacts.phone && isMobileNumber(contacts.phone)));

    const handlePhone = () => {
        trackActivityContact("phone", entityId, entityType, placement);
        window.location.href = `tel:${contacts.phone}`;
    };

    const handleEmail = () => {
        trackActivityContact("email", entityId, entityType, placement);
        window.location.href = `mailto:${contacts.email}`;
    };

    return (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 6 }}>
            {showWhatsapp && (
                <a href={`${base}&type=whatsapp`} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                    💬 WhatsApp
                </a>
            )}
            {contacts.phone && (
                <button onClick={handlePhone} style={linkStyle}>📞 Chiama</button>
            )}
            {contacts.website && (
                <a href={`${base}&type=website`} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                    🌐 Sito
                </a>
            )}
            {contacts.email && (
                <button onClick={handleEmail} style={linkStyle}>✉️ Email</button>
            )}
        </div>
    );
}

const linkStyle = {
    display: "inline-flex", alignItems: "center", gap: 4,
    padding: "4px 10px", borderRadius: 20, fontSize: 13,
    background: "#f0f0f0", color: "#333", textDecoration: "none",
    border: "1px solid #ddd", cursor: "pointer",
};
